import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageuploadComponent } from 'src/app/imageupload/imageupload.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { BannerService } from 'src/app/_services/banner.service';
import { ToastService } from 'src/app/_services/toastservice';

@Component({
  selector: 'app-addbanner',
  templateUrl: './addbanner.component.html',
  styleUrls: ['./addbanner.component.css']
})
export class AddbannerComponent implements OnInit {

  submitted = false;
  bannerForm: FormGroup;
  loading = false;
  loadingCustomer = false;
  ButtonText = "Save"; 
  public FormsList: string[] = ["Home", "About", "Contact", "Shop",  "Cart" , "Checkout","Other"];
  showDeviceType: boolean = false;

  @ViewChild(ImageuploadComponent, { static: true }) imgComp;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private ls: LocalStorageService,
    public ts: ToastService,
    private bannerService: BannerService

  ) {
    this.createForm();
    
  }

  ngOnInit() {
    this.setSelectedCustomer();
  }

  get f() { return this.bannerForm.controls; }

  private createForm() {
    debugger
    this.bannerForm = this.formBuilder.group({
      title: ['',Validators.required],
      description: [''],
      mainHeading: [''],
      //arabicTitle: ['', Validators.required],
      //arabicDescription: [''],
      //arabicMainHeading: [''],
      formName:['Others'],
      deviceType: ['Desktop'],
      statusID: [true],
      bannerID: 0,
      image: [''],
      brandID: this.ls.getSelectedUser().brandID,
      locationID: null
    });
  }

private editForm(obj) {
    this.f.title.setValue(obj.title);
    this.f.mainHeading.setValue(obj.mainHeading);
    this.f.description.setValue(obj.description);

    // this.f.arabicTitle.setValue(obj.arabicTitle);
    // this.f.arabicMainHeading.setValue(obj.arabicMainHeading);
    // this.f.arabicDescription.setValue(obj.arabicDescription);

    this.f.formName.setValue(obj.formName);
    this.f.deviceType.setValue(obj.deviceType);
    this.f.bannerID.setValue(obj.bannerID);
    this.f.image.setValue(obj.image);
    this.f.statusID.setValue(obj.statusID === 1 ? true : false);
    this.imgComp.imageUrl = obj.image;
}

  setSelectedCustomer() {
    this.route.paramMap.subscribe(param => {
      const sid = +param.get('id');
      if (sid) {
        this.loadingCustomer = true;
        this.f.bannerID.setValue(sid);
        this.bannerService.getById(sid).subscribe(res => {
          //Set Forms
          this.editForm(res);
          this.loadingCustomer = false;
        });
      }
    })
  }




onFormNameChange(event: any) {
  const selectedValue = event.target.value;

  if (selectedValue === 'Home') {
    this.showDeviceType = true;
  } else {
    // Hide dropdown and force Desktop value
    this.showDeviceType = false;
    this.bannerForm.patchValue({ deviceType: 'Desktop' });
  }
}


  onSubmit() {
    debugger
    this.bannerForm.markAllAsTouched();
    this.submitted = true;
    if (this.bannerForm.invalid) { return; }
    this.loading = true;
    this.f.statusID.setValue(this.f.statusID.value === true ? 1 : 2);
    this.f.image.setValue(this.imgComp.imageUrl);

    if (parseInt(this.f.bannerID.value) === 0) {
      //Insert banner
      console.log(JSON.stringify(this.bannerForm.value));
      this.bannerService.insert(this.bannerForm.value).subscribe(data => {
        debugger
        if (data != 0) {
          this.ts.showSuccess("Success","Record added successfully.")
          this.router.navigate(['/admin/banner']);
        }
        this.loading = false;
      }, error => {
        this.ts.showError("Error","Failed to insert record.")
        this.loading = false;
      });
    } else {
      //Update banner
      this.bannerService.update(this.bannerForm.value).subscribe(data => {
        this.loading = false;
        if (data != 0) {
          this.ts.showSuccess("Success","Record updated successfully.")
          this.router.navigate(['/admin/banner']);
        }
      }, error => {
        this.ts.showError("Error","Failed to update record.")
        this.loading = false;
      });
    }
  }


  }

